import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { TiledeskStatus } from "@modules/tiledesk/types";
import { getTiledeskStatusService } from "./service";

export const tiledeskStatusQueryKey = (agreementId: string) => [
  "tiledesk-status",
  agreementId,
];

export function useTiledeskStatusQuery(
  agreementId?: string,
  options?: Omit<UseQueryOptions<TiledeskStatus>, "queryKey" | "queryFn">
) {
  return useQuery({
    queryKey: tiledeskStatusQueryKey(agreementId as string),
    queryFn: () => getTiledeskStatusService(agreementId as string),
    enabled: !!agreementId,
    ...options,
  });
}
